import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { AuthStatusGate } from "~/auth/PrivateRoute";
import { useAuth } from "~/auth/AuthProvider";
import { getHomePath } from "~/auth/permissions";
import { clearReturnTo, readReturnTo } from "~/auth/returnTo";

function HomeRedirect() {
  const { me } = useAuth();
  // Lê no render (sem remover) e limpa no efeito: seguro com o render duplo do StrictMode.
  // Sem permissão nenhuma: /acesso-negado sem ref = variante genérica (não há mais ?motivo=, P1-6).
  const target = readReturnTo() || getHomePath(me) || "/acesso-negado";
  useEffect(() => {
    clearReturnTo();
  }, []);
  return <Navigate to={target} replace />;
}

export default function AdminHome() {
  return (
    <AuthStatusGate>
      <HomeRedirect />
    </AuthStatusGate>
  );
}
